
import './App.css';
import Footer from './Componant/Footer/Footer';
import NavigationBar from './Componant/Navbar/Navbar';
import Home from './Componant/Pages/Home';
import Contact from './Componant/Pages/Contact'
import About from './Componant/Pages/About';
import {  Routes, Route } from "react-router-dom";
import  Booking  from './Componant/Pages/Booking';
import Service from './Componant/Pages/Service';
import Error404 from './Componant/Pages/Error404';
import SignUp from './Componant/Pages/SignUp';
import Login from './Componant/Pages/Login';
import  Blog from './Componant/Pages/Blog';
function App() {
  return (
    <div className="App">
      <NavigationBar />
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/service" element={<Service />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/error" element={<Error404 />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/blog" element={<Blog />} />
          </Routes>
      <Footer/>
    </div>
  );
}

export default App;
